import { render, staticRenderFns } from "./qz-tray-printers.vue?vue&type=template&id=224f47be&"
import script from "./qz-tray-printers.vue?vue&type=script&lang=js&"
export * from "./qz-tray-printers.vue?vue&type=script&lang=js&"
import style0 from "./qz-tray-printers.vue?vue&type=style&index=0&id=224f47be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports